import GatewayGet from './Get'
import GatewayCreate from './Create'
import GatewayUpdate from './Update'
import GatewayDetails from './Details'
import GatewayAllotment from './Allotment'
import GatewayTransactionsReport from './TransactionsReport'

export {
    GatewayGet,
    GatewayCreate,
    GatewayUpdate,
    GatewayDetails,
    GatewayAllotment,
    GatewayTransactionsReport
}